const AUCTION_STATUS_UPDATED = 'AUCTION_STATUS_UPDATED';
const AFTER_AUCTION_STATUS_UPDATED = 'AFTER_AUCTION_STATUS_UPDATED';
const INSTANT_BID_MODAL_OPENED = 'INSTANT_BID_MODAL_OPENED';
const INSTANT_BID_CONFIRMED = 'INSTANT_BID_CONFIRMED';
const AUTO_BID_MODAL_OPENED = 'AUTO_BID_MODAL_OPENED';
const AUTO_BID_CONFIRMED = 'AUTO_BID_CONFIRMED';
const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
const AUCTION_TIME_ENDED = 'AUCTION_TIME_ENDED';
const CURRENT_USER_WON = 'CURRENT_USER_WON';
const CURRENT_USER_NOT_WON = 'CURRENT_USER_NOT_WON';
const CONNECTION_ESTABLISHED = 'CONNECTION_ESTABLISHED';
const CONNECTION_CHECK = 'CONNECTION_CHECK';
const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
const AUCTION_CLOSED = 'AUCTION_CLOSED';
const AUCTION_TIME_STARTS = 'AUCTION_TIME_STARTS';
const REQUEST_AUCTION_STATUS_UPDATE = 'REQUEST_AUCTION_STATUS_UPDATE';
const AUTO_BID_EXPIRED = 'AUTO_BID_EXPIRED';

const events = [
  AUCTION_STATUS_UPDATED,
  AFTER_AUCTION_STATUS_UPDATED,
  INSTANT_BID_MODAL_OPENED,
  INSTANT_BID_CONFIRMED,
  AUTO_BID_MODAL_OPENED,
  AUTO_BID_CONFIRMED,
  SHOW_NOTIFICATION,
  CLEAR_NOTIFICATION,
  AUCTION_TIME_ENDED,
  CURRENT_USER_WON,
  CURRENT_USER_NOT_WON,
  CONNECTION_ESTABLISHED,
  CONNECTION_CHECK,
  AUCTION_CLOSED,
  AUCTION_TIME_STARTS,
  REQUEST_AUCTION_STATUS_UPDATE,
  AUTO_BID_EXPIRED
];

const initializeEventListeners = () => {
  EVENT_BUS.registerEvents(events);
};

export const AUCTION_EVENTS = {
  AUCTION_STATUS_UPDATED,
  AFTER_AUCTION_STATUS_UPDATED,
  INSTANT_BID_MODAL_OPENED,
  INSTANT_BID_CONFIRMED,
  AUTO_BID_MODAL_OPENED,
  AUTO_BID_CONFIRMED,
  AUCTION_TIME_ENDED,
  CURRENT_USER_WON,
  CURRENT_USER_NOT_WON,
  AUCTION_CLOSED,
  CONNECTION_CHECK,
  CONNECTION_ESTABLISHED,
  AUCTION_TIME_STARTS,
  REQUEST_AUCTION_STATUS_UPDATE,
  AUTO_BID_EXPIRED,
  SHOW_NOTIFICATION,
  CLEAR_NOTIFICATION,
  initializeEventListeners,
};
